import React, { useState, useEffect } from "react";
import { Helmet } from 'react-helmet-async';
import userlogo from '../../user.webp';
import { FaCircle, FaCopy, FaFacebook, FaTwitter, FaWhatsapp } from "react-icons/fa";
import { ArrowRight, Circle } from "react-feather";
import Sidebar from './sidebar';
import api from "../api";

const AffiliateDashboard = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;    
    const token = localStorage.getItem("access_token");
    const [affiliateLink, setAffiliateLink] = useState("");
    const [copied, setCopied] = useState(false);
    const [stats, setStats] = useState({
        totalReferrals: 0,
        payingReferrals: 0,
    });
    const [referrals, setReferrals] = useState([]);

    // ✅ Copy to Clipboard
    const copyToClipboard = () => {
        navigator.clipboard.writeText(affiliateLink);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2s
    };

    // ✅ Fetch Stats & Referrals from API
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await api.get("/vendor/affiliate-stats/", {
            headers: {
                Authorization: `Bearer ${token})}`,
            },
            });
            setStats(response.data.stats);
            setAffiliateLink(response.data.affiliate_link);
            setReferrals(response.data.referrals);

        } catch (error) {
            //console.error("Error fetching products:", err.toJSON());
        }
    }

    const shareText = `${affiliateLink}`;
    const socialLinks = {
        whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`,
        twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(affiliateLink)}`,
        instagram: "https://www.instagram.com/", // Instagram doesn't allow direct URL sharing
    };

  return (
    <>                  
            <Helmet>
                <title>Affiliate</title>
                <meta name="description" content={`Affiliate`} />
            </Helmet>
            <section className="container mtopcon dashb">         
                <div className="row">
                    
                        <div className="col-12 col-lg-2 dash-min mb-3">
                            <div className="nav-left-sidebar sidebar-dark pc">
                                <div className="slimScrollDiv" ><div className="menu-list" >
                                    <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                                        <a className="d-xl-none d-lg-none" href="#"></a>
                                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                                            <span className="navbar-toggler-icon"></span>
                                        </button>
                                        <div className="collapse navbar-collapse" id="navbarNav">
                                            <Sidebar/>
                                        </div>
                                    </nav>
                                </div><div className="slimScrollBar"></div><div className="slimScrollRail"></div></div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-10 dash-max">
                            <div className="row ph-header-con">
                                <div className="col-7 pt-2"><h6 className="pageheader-title mb-3">Affiliate Dashboard </h6></div>
                            </div>
                            
                            <div className="row d-flex justify-content-center">
                                <div className="col-12 col-lg-4">
                                    <div className="mt-4">
                                            {/* Stats Row */}
                                            <div className="row text-left mb-0">
                                                <div className="col-6 col-md-6">
                                                <div className="card p-3">
                                                    <h6 className="font90x">Total Referrals</h6>
                                                    <h4 className="fw-bold">{stats.totalReferrals}</h4>
                                                </div>
                                                </div>
                                                <div className="col-6 col-md-6">
                                                <div className="card p-3">
                                                    <h6 className="font90x">Paying Referrals</h6>
                                                    <h4 className="fw-bold">{stats.payingReferrals}</h4>
                                                </div>
                                                </div>
                                            </div>

                                            {/* Affiliate Link with Copy Button */}

                                            <div className="card shadow-sm border border-secondary border-opacity-10">
                                            <div className="card-body pymtdiv"> 
                                                <div className="accordion accordion-flush" id="accordionFlushExample">
                                                    <div className="accordion-item">
                                                        <h2 className="accordion-header">
                                                        <button className="accordion-button collapsed p-0" type="button" data-bs-toggle="collapse" data-bs-target="#flush-coll2" aria-expanded="false" aria-controls="flush-coll2">                                                            
                                                            <label htmlFor="lnm" className="form-label mb-0 font9"><b>Your Affiliate Link</b></label>
                                                        </button>
                                                        </h2>
                                                        <div id="flush-coll2" className="accordion-collapse collapse paymethod" data-bs-parent="#accordionFlushExample">
                                                            <div className="accordion-body mt-3">
                                                                    <div className="bg-light p-2 rounded font-bold small mb-3">
                                                                        <code>{affiliateLink}</code>
                                                                    </div>
                                                                    <div className="mt-1 mb-3">
                                                                        <button
                                                                            className="col-12 btn btn-outline-dark d-flex align-items-center gap-2"
                                                                            style={{ borderWidth: "4px" }}
                                                                            onClick={copyToClipboard}
                                                                        >
                                                                            <FaCopy /> {copied ? "Copied!" : "Copy Link"}
                                                                        </button>
                                                                    </div>                                                    
                                                                    <hr/>
                                                                    <h6 className="mt-2 text-center">Share On</h6>
                                                                    {/* Share Buttons */}
                                                                    <div className="d-flex justify-content-around mt-2 font9 pb-4">
                                                                        <a href={socialLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="btn btn-success ms-2">
                                                                            <FaWhatsapp size={24} />
                                                                        </a>
                                                                        <a href={socialLinks.twitter} target="_blank" rel="noopener noreferrer" className="btn btn-info text-white ms-2">
                                                                            <FaTwitter size={24} />
                                                                        </a>
                                                                        <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="btn btn-primary ms-2">
                                                                            <FaFacebook size={24} />
                                                                        </a>
                                                                    </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                            {/* Referrals List */}
                                            <h6 className="fw-bold mt-5 mb-3">Your Referrals</h6>
                                            <div className="referral-list">
                                                {referrals.length === 0 ? (
                                                <p>No referrals yet.</p>
                                                ) : (
                                                referrals.map((item, index) => (
                                                    <div className="row ord-bg lh0 bg-white p-2 hvr bx-shadow mlrnew mb-2" key={index}>
                                                        <div className="col-2 p-0">
                                                            <div className="ord-img float-left">
                                                                <img src={userlogo} alt="User" className="w-100 h-100" />
                                                            </div>
                                                        </div>
                                                        <div className="col-9 pl-0 pr-0">
                                                                <div className="col-12 p-1 font-bold">{item.name}</div>
                                                                <div className="col-12 p-1 grey-text">{item.email}</div>
                                                        </div>
                                                        <div className="col-1 f8 text-black prodedtbtn text-right p-0 mt-1 lh34">
                                                            <button className="btn btn-default border-0">
                                                                <FaCircle className="text-success" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))
                                                )}
                                            </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </section>
        </>
  );
};

export default AffiliateDashboard;
